// LAP-550 — Conteneur Markeet refactoré (CardShell + bandeau ticker amélioré)
import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Typography } from '@mui/material'
import { makeGetRequest } from 'utils/api'
import './slider.css'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import MarketCard from './cards/MarketCard'
import CommoditiesCard from './cards/CommoditiesCard'
import RealEstateCard from './cards/RealEstateCard'
import AlternativeInvestmentCard from './cards/AlternativeInvestmentCard'
import StartupsCard from './cards/StartupsCard'
import CurrencyExchange from './cards/CurrencyExchange'
import CardShell from '../_shared/CardShell'
import { invTheme } from '../_shared/theme'

export default function MarkeetTab() {
  const [reports, setReports] = useState([])
  useEffect(() => {
    getMarketView()
  }, [])
  const getMarketView = async () => {
    const { data } = await makeGetRequest('/api/investment/market-view/', {}, true)
    setReports([...data])
  }
  return (
    <>
      {/* LAP-550 — Ticker bandeau plus dense et lisible */}
      <Box
        sx={{
          mt: 1,
          mb: 1,
          py: 0.75,
          width: '100%',
          overflow: 'hidden',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          background: 'linear-gradient(90deg, rgba(0,18,44,0.6), rgba(0,27,66,0.85), rgba(0,18,44,0.6))',
          borderRadius: invTheme.cardRadius,
          border: invTheme.cardBorder,
        }}
      >
        <Box className="slider-track">
          {reports
            .find((r) => r.type === 'market_snapshot')
            ?.data.map((item, index) => (
              <Box
                key={index}
                sx={{
                  px: 2.5,
                  whiteSpace: 'nowrap',
                  display: 'inline-flex',
                  alignItems: 'center',
                  borderRight: '1px solid rgba(255,255,255,0.07)',
                }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, mr: 1, opacity: 0.85 }}>
                  {item.indice_name}
                </Typography>
                <Typography variant="body2" sx={{ mr: 0.5 }}>
                  {parseFloat(item.price).toFixed(2)}
                </Typography>
                {item.variation_percent >= 0 ? (
                  <ArrowDropUpIcon sx={{ color: invTheme.positive, fontSize: '1.6rem', ml: -0.5 }} />
                ) : (
                  <ArrowDropDownIcon sx={{ color: invTheme.negative, fontSize: '1.6rem', ml: -0.5 }} />
                )}
                <Box
                  component="span"
                  sx={{
                    color: item.variation_percent >= 0 ? invTheme.positive : invTheme.negative,
                    fontWeight: 600,
                    fontSize: 13,
                  }}
                >
                  {parseFloat(item.variation_percent).toFixed(2)}%
                </Box>
              </Box>
            ))}
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1, pb: 6, mt: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.market} detailTo="/investments/market/financial">
              <MarketCard result={reports.find((r) => r.type === 'financial_market')?.data} />
            </CardShell>
          </Grid>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.commodities} detailTo="/investments/market/commodities">
              <CommoditiesCard result={reports.find((r) => r.type === 'commodity_market')?.data} />
            </CardShell>
          </Grid>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.realEstate} detailTo="/investments/market/realestate">
              <RealEstateCard
                result={reports.find((r) => r.type === 'real_estate_opportunity')?.data}
              />
            </CardShell>
          </Grid>
        </Grid>
        <Grid mt={0} container spacing={2}>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.alternative} detailTo="/investments/market/alternative">
              <AlternativeInvestmentCard
                result={reports.find((r) => r.type === 'alternatifs')?.data}
              />
            </CardShell>
          </Grid>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.startups} detailTo="/investments/market/startups">
              <StartupsCard result={reports.find((r) => r.type === 'startup_capital')?.data} />
            </CardShell>
          </Grid>
          <Grid item xs={12} md={4}>
            <CardShell accent={invTheme.accents.forex} detailTo="/investments/market/forex">
              <CurrencyExchange
                result={reports.find((r) => r.type === 'currency_exchange')?.data}
              />
            </CardShell>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
